module.exports = __webpack_public_path__ + "assets/a40a83a8027ff540921e181d3b991257.png";